import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter, Route, Routes } from 'react-router'
import { AppShell } from './layout/AppShell.js'
import { Anmelden } from './pages/Anmelden.js'
import { Auswertung } from './pages/Auswertung.js'
import { Einstellungen } from './pages/Einstellungen.js'
import { Kontakte } from './pages/Kontakte.js'
import { Uebersicht } from './pages/Uebersicht.js'
import { Verlauf } from './pages/Verlauf.js'
import { Zugang } from './pages/Zugang.js'
import { SitzungProvider } from './session/SitzungContext.js'
// Einziger Stil-Einstieg, gemeinsam mit der Kundenverwaltung (`packages/ui`).
import '@nac2s/ui/oberflaeche.css'

const container = document.getElementById('root')
if (!container) throw new Error('Wurzelelement #root nicht gefunden')

createRoot(container).render(
  <StrictMode>
    <BrowserRouter>
      <SitzungProvider>
        <Routes>
          {/* Ohne Rahmen: Beim Einlösen der Übergabe gibt es noch keine Sitzung,
              und eine Navigation wäre irreführend. */}
          <Route path="/anmelden" element={<Anmelden />} />
          {/* Passwort setzen ueber den Zugangslink — ebenfalls ohne Rahmen. */}
          <Route path="/zugang" element={<Zugang />} />

          <Route element={<AppShell />}>
            <Route index element={<Uebersicht />} />
            <Route path="einstellungen" element={<Einstellungen />} />
            <Route path="verlauf" element={<Verlauf />} />
            <Route path="kontakte" element={<Kontakte />} />
            <Route path="auswertung" element={<Auswertung />} />
            <Route path="*" element={<NichtGefunden />} />
          </Route>
        </Routes>
      </SitzungProvider>
    </BrowserRouter>
  </StrictMode>,
)

function NichtGefunden() {
  return (
    <div className="px-6 py-8">
      <h1 className="font-display text-xl font-bold text-primary">Seite nicht gefunden</h1>
      <p className="mt-2 text-sm text-tertiary">Diese Adresse gibt es nicht.</p>
    </div>
  )
}
